import React from "react";
import { closeOutline } from "ionicons/icons";
import { useTranslation } from "react-i18next";

import {
  IonButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonIcon,
  IonModal,
  IonTitle,
  IonToolbar
} from "@ionic/react";

import PrivacyContentEN from "../pages/5.More/Help/Privacy/PrivacyContentEN";
import { PrivacyContentRO } from "../pages/5.More/Help/Privacy/PrivacyContentRO";
import type { ModalProps } from "../types/otherTypes";

const ModalPrivacy: React.FC<ModalProps> = ({
  showModal,
  setShowModal,
  lang
}) => {
  const { t } = useTranslation();

  return (
    <IonModal isOpen={showModal} onDidDismiss={() => setShowModal(false)}>
      <IonHeader>
        <IonToolbar>
          <IonTitle>{t("privacyPolicy")}</IonTitle>
          <IonButtons slot="end">
            <IonButton onClick={() => setShowModal(false)}>
              <IonIcon slot="icon-only" icon={closeOutline} />
            </IonButton>
          </IonButtons>
        </IonToolbar>
      </IonHeader>

      <IonContent>
        {lang === "en" ? <PrivacyContentEN /> : <PrivacyContentRO />}
      </IonContent>
    </IonModal>
  );
};

export default ModalPrivacy;
